// styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, FontWeight } from '../../../../assets/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  table: {
    marginBottom: 80,
    marginTop: 30,
  },
  main: {
    paddingLeft: '35px',
    paddingBottom: '20px',
    '&.download': {
      paddingLeft: '20px',
      paddingBottom: '8px',
      breakBefore: 'page',
      pageBreakBefore: 'always',
      },
  },

  tableContainer: {
    backgroundColor: 'white',
    borderRadius: '5px',
    marginBottom: '20px',
  },
  columnTitle: {
    fontSize: '16px !important',
    fontWeight: `${FontWeight.Bold} !important`,
    color: `${Colors.Black} !important`,
    paddingLeft: '20px !important',
    padding: '8px !important',
  },
  columnSubTitle: {
    color: Colors.Black,
    fontWeight: FontWeight.Bold,
    fontSize: 16,
    padding: '8px',
  },
  sectionTitle: {
    fontSize: '16px !important',
    fontWeight: FontWeight.Light,
    color: Colors.Black,
    padding: '8px',
  },
  subsectionTitle: {
    fontSize: '16px !important',
    fontWeight: `${FontWeight.Light} !important`,
    color: `${Colors.Black} !important`,
    paddingLeft: '30px !important',
    padding: '8px !important',
  },
  sectionAmount: {
    width: '8% !important',
    color: Colors.Gray,
    fontSize: 14,
    padding: '8px',
  },
  subsectionAmount: {
    width: '8% !important',
    color: Colors.Gray,
    fontSize: 14,
    padding: '8px',
  },
  contentTitle: {
    marginBottom: '24px !important',
  },
}));

export const useTableCellStyles = makeStyles((theme: Theme) => ({
  root: {
    '&.MuiTable-root':{
      border: `1px solid ${Colors.Gray5}`,
    },
  },
  cell:{
    '&.MuiTableCell-root':{
      border: `1px solid ${Colors.Gray5}`,
    }
  },
}));